import React from 'react';
import './Ticker.css';
import { notices } from '../data/schoolData';

export default function Ticker() {
  const doubled = [...notices, ...notices]; // seamless loop
  return (
    <div className="ticker">
      <div className="ticker-label">📢 NOTICE</div>
      <div className="ticker-wrap">
        <div className="ticker-track">
          {doubled.map((n, i) => <span key={i}>{n}</span>)}
        </div>
      </div>
    </div>
  );
}
